import request from '@/utils/request'
const qs = require('qs')
export function listPerInvoice(data) {
  return request({
    url: '/report_penjualan/list_per_invoice',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerInvoice(data) {
  return request({
    url: '/report_penjualan/total_trx_per_invoice',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerProduct(data) {
  return request({
    url: '/report_penjualan/list_per_product',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerProduct(data) {
  return request({
    url: '/report_penjualan/total_trx_per_product',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}


export function listPerCashier(data) {
  return request({
    url: '/report_penjualan/list_per_cashier',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerCashier(data) {
  return request({
    url: '/report_penjualan/total_trx_per_cashier',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerPembayaranPiutang(data) {
  return request({
    url: '/report_penjualan/list_per_pembayaran_piutang',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerPembayaranPiutang(data) {
  return request({
    url: '/report_penjualan/total_trx_per_pembayaran_piutang',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerShift(data) {
  return request({
    url: '/report_penjualan/list_per_shift',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerShift(data) {
  return request({
    url: '/report_penjualan/total_trx_per_shift',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerTipePembayaran(data) {
  return request({
    url: '/report_penjualan/list_per_tipe_pembayaran',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerTipePembayaran(data) {
  return request({
    url: '/report_penjualan/total_trx_per_tipe_pembayaran',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerDokter(data) {
  return request({
    url: '/report_penjualan/list_per_dokter',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerDokter(data) {
  return request({
    url: '/report_penjualan/total_trx_per_dokter',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerPelanggan(data) {
  return request({
    url: '/report_penjualan/list_per_pelanggan',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerPelanggan(data) {
  return request({
    url: '/report_penjualan/total_trx_per_pelanggan',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerTipeProduk(data) {
  return request({
    url: '/report_penjualan/list_per_tipe_produk',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerTipeProduk(data) {
  return request({
    url: '/report_penjualan/total_trx_per_tipe_produk',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerUmurPiutang(data) {
  return request({
    url: '/report_penjualan/list_per_umur_piutang',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function totalTrxPerUmurPiutang(data) {
  return request({
    url: '/report_penjualan/total_trx_per_umur_piutang',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPerPiutang(data) {
  return request({
    url: '/report_penjualan/list_data_piutang',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/reportSale.js